import React, { useEffect } from 'react';
import { useState } from 'react';
import { defaultTheme } from 'react-admin';
import { useOktaAuth } from '@okta/okta-react';
import Avatar from '@mui/material/Avatar';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Button, CardActions, CircularProgress } from '@mui/material';
import { LocalData } from '../../utils/localData';

const LoginPage:React.FC = () => {
  const { oktaAuth } = useOktaAuth();
  const [loading, setLoading] = useState(true);

  const onLoginClick = async () => { 
    setLoading(true);
    await oktaAuth.signInWithRedirect();
    setLoading(false);
  }

  const onClearLocalDataClick = async () => { 
    LocalData.clearData(document, window, location)
  }
  
  // Show a spinner while we check for an access token
  useEffect(() => {
    async function checkToken() {
      for (let i = 0; i < 20; i++) {
        if (localStorage.getItem('accessToken')) {
          await new Promise(resolve => setTimeout(resolve, 100))
        }
      }
      setLoading(false)
    }
    checkToken()
  }, [])

  return (
    <ThemeProvider theme={createTheme(defaultTheme)}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <CardActions>
            <Button
              variant="contained"
              type="submit"
              color="primary"
              onClick={onLoginClick}
              disabled={loading}
            >
              {loading && (
                <CircularProgress
                  size={18}
                  thickness={2}
                  sx={{ mr: 1 }}
                />
              )}
                Login With Okta
            </Button>
            <br />
          </CardActions>
          <Button
            size="small"
            type="submit"
            color="primary"
            onClick={onClearLocalDataClick}
            disabled={loading}
            sx={{mt: 2}}
          >
                Clear Cache and Cookies
          </Button>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default LoginPage;